import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeFromCart } from "../actions/cartActions";
import { FaTimes } from "react-icons/fa";

const CartDrawer = ({ onClose }) => {
    const cart = useSelector(state => state.cart);
    const dispatch = useDispatch();

    const handleRemoveFromCart = (id) => {
        dispatch(removeFromCart(id));
    };

    const [userName, setUserName] = useState("");
    const [shippingOption, setShippingOption] = useState("retiro"); // "retiro" o "envio"
    const [address, setAddress] = useState("");

    const groupedCart = cart.reduce((acc, product) => {
        const existingProduct = acc.find(item => item.id === product.id);
        if (existingProduct) {
            existingProduct.quantity += 1;
        } else {
            acc.push({ ...product, quantity: 1 });
        }
        return acc;
    }, []);

    const total = groupedCart.reduce((acc, product) => {
        const price = parseFloat(product.price.replace(/[^\d.-]/g, ''));
        return acc + price * product.quantity;
    }, 0);

    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(price);
    };

    const generateWhatsAppMessage = () => {
        let message = `Hola, me llamo ${userName}, me gustaría comprar los siguientes productos:\n\n`;
        groupedCart.forEach(product => {
            const price = parseFloat(product.price.replace(/[^\d.-]/g, ''));
            message += `${product.quantity} x ${product.name} - ${formatPrice(price)}\n`;
        });

        message += `\nTotal sin envío: ${formatPrice(total)}\n\n`;

        if (shippingOption === "envio") {
            message += `Envio a: ${address}\n`;
        }

        return encodeURIComponent(message);
    };

    const handleSubmit = () => {
        if (!userName) {
            alert("Por favor, ingresa tu nombre.");
            return;
        }

        const message = generateWhatsAppMessage();
        window.open(`https://wa.me/+5491164106135?text=${message}`, "_blank");
    };

    return (
        <div className="fixed inset-0 flex justify-end z-50">
            <div className="bg-black bg-opacity-50 w-full h-full" onClick={onClose}></div>
            <div className="bg-gray-200 w-80 h-full p-4 rounded-l-lg">
                <div className="flex justify-between items-center border-b pb-2">
                    <h2 className="text-lg font-bold">Carrito de compras</h2>
                    <button onClick={onClose} className="text-red-500">
                        <FaTimes />
                    </button>
                </div>
                <div className="mt-4">
                    {groupedCart.length === 0 ? (
                        <p>No hay productos en el carrito.</p>
                    ) : (
                        groupedCart.map((product, index) => (
                            <div key={index} className="flex justify-between items-center border-b py-2">
                                <div>
                                    <p>{product.quantity} x {product.name}</p>
                                    <p>{formatPrice(parseFloat(product.price.replace(/[^\d.-]/g, '')))}</p>
                                </div>
                                <button onClick={() => handleRemoveFromCart(product.id)} className="text-red-500">Eliminar</button>
                            </div>
                        ))
                    )}
                </div>

                {groupedCart.length > 0 && (
                    <>
                        <div className="flex justify-between items-center mt-4 font-bold">
                            <span>Total sin envío:</span>
                            <span>{formatPrice(total)}</span>
                        </div>
                        <div className="mt-4">
                            <label htmlFor="name" className="block font-bold">Nombre</label>
                            <input
                                type="text"
                                id="name"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded mt-2"
                            />
                        </div>
                        <div className="mt-4">
                            <label className="font-bold">Selecciona una opción</label>
                            <div className="flex items-center mt-2">
                                <input
                                    type="radio"
                                    id="retiro"
                                    name="shippingOption"
                                    value="retiro"
                                    checked={shippingOption === "retiro"}
                                    onChange={() => setShippingOption("retiro")}
                                />
                                <label htmlFor="retiro" className="ml-2">Coordinar entrega</label>
                            </div>
                            <div className="flex items-center mt-2">
                                <input
                                    type="radio"
                                    id="envio"
                                    name="shippingOption"
                                    value="envio"
                                    checked={shippingOption === "envio"}
                                    onChange={() => setShippingOption("envio")}
                                />
                                <label htmlFor="envio" className="ml-2">Envío</label>
                            </div>
                        </div>
                        {shippingOption === "envio" && (
                            <div className="mt-4">
                                <label htmlFor="address" className="block font-bold">Dirección</label>
                                <input
                                    type="text"
                                    id="address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    className="w-full p-2 border border-gray-300 rounded mt-2"
                                />
                            </div>
                        )}
                        <div className="mt-4">
                            <button
                                onClick={handleSubmit}
                                className="px-4 py-2 bg-green-500 text-white rounded-full w-full"
                            >
                                Finalizar compra
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CartDrawer;
